import FeedbackService from './FeedbackService';

import apiService from '../ApiService';

export default new FeedbackService(apiService);
